import * as React from "react";
import { createElasticsearchQueryString } from "views/logic/queries/Query";
import { DEFAULT_TIMERANGE } from "views/Constants";
const defaultValue = {
  query: createElasticsearchQueryString(""),
  streams: [],
  streamCategories: [],
  timerange: DEFAULT_TIMERANGE
};
const DrilldownContext = React.createContext(defaultValue);
export default DrilldownContext;
